<div
    [formGroup]="form"
    *ngIf="pathOpts?.length > 1"
>
    <label
        class="mr-3 mb-0"
        id="insightPath"
        >{{ i18n._822_DRILL_PATH | translate }}</label
    >
    <div class="d-inline-block">
        <ng-select
            [options]="pathOpts"
            [placeholder]="'&nbsp;'"
            [ariaLabelledBy]="'insightPath'"
            [formControlName]="'path'"
        ></ng-select>
    </div>
</div>
